// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RequestSummaryItemModel from '../../model/request-summary-item-model';
import RequestSummaryItemDTO from '../dto/request-summary-item-dto';
import dtoSchema from '../schemas/request-summary-item-schema';

export default abstract class RequestSummaryItemModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RequestSummaryItemDTO>) {
    super();
    if (data) {
      this.downloadLink = data.downloadLink ?? undefined;
      this.label = data.label ?? undefined;
      this.displayValue = data.displayValue ?? undefined;
    }
  }
  /**
  */
  downloadLink?: string;
  /**
  */
  label?: string;
  /**
  */
  displayValue?: string;

  static toModel(dto: DeepPartial<RequestSummaryItemDTO>): RequestSummaryItemModel;
  static toModel(dto: DeepPartial<RequestSummaryItemDTO> | undefined | null): RequestSummaryItemModel | undefined;
  static toModel(dto: DeepPartial<RequestSummaryItemDTO> | undefined | null): RequestSummaryItemModel | undefined {
    return dto ? new RequestSummaryItemModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RequestSummaryItemModel> | RequestSummaryItemModel): RequestSummaryItemDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      downloadLink: unwrapped.downloadLink,
      label: unwrapped.label,
      displayValue: unwrapped.displayValue,
    } as RequestSummaryItemDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RequestSummaryItemModel, can not map to RequestSummaryItemDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
